var _excluded = ["buttons", "monthEventFill", "events", "form", "onSelectSlot", "mountNode", "defaultDate"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useEffect, useCallback, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/fr';
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import "./calendar.css";
import Toolbar from "./Toolbar";
import EventWrapper from "./EventWrapper";
import DateCellWrapper from "./DateCellWrapper";

/**
 * Calendar
 */
import { jsx as _jsx } from "react/jsx-runtime";
var Calendar = function Calendar(props) {
  var buttons = props.buttons,
    monthEventFill = props.monthEventFill,
    events = props.events,
    form = props.form,
    onSelectSlot = props.onSelectSlot,
    mountNode = props.mountNode,
    defaultDate = props.defaultDate,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  moment.locale('fr');
  var localizer = momentLocalizer(moment);
  var segmentRef = /*#__PURE__*/React.createRef();
  var _useState = useState(null),
    valueOpen = _useState[0],
    setValueOpen = _useState[1];
  var _useState2 = useState([]),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  var getIsOpen = useCallback(function (val) {
    return moment(valueOpen).format('Y-MM-DD') === moment(val).format('Y-MM-DD');
  }, [valueOpen]);
  var handleClose = useCallback(function () {
    setValueOpen(null);
    setSelectedTab([]);
  }, [setValueOpen, setSelectedTab]);
  var renderDateCellWrapper = useCallback(function (propsDCW) {
    return /*#__PURE__*/_jsx(DateCellWrapper, Object.assign({
      form: form,
      segmentRef: segmentRef
    }, propsDCW, {
      openPopup: getIsOpen(propsDCW.value),
      selectedTab: selectedTab,
      onClose: handleClose,
      mountNode: mountNode
    }));
  }, [mountNode, getIsOpen, form, selectedTab, handleClose, segmentRef]);
  var handleSelectSlot = function handleSelectSlot(slotEvent) {
    if (monthEventFill) {
      if (moment(slotEvent.slots[slotEvent.slots.length - 1]).format('Y-MM-DD') === moment(valueOpen).format('Y-MM-DD')) {
        setValueOpen(null);
        setSelectedTab([]);
      } else {
        setValueOpen(slotEvent.slots[slotEvent.slots.length - 1]);
        setSelectedTab(slotEvent.slots);
      }
    }
    if (onSelectSlot) {
      onSelectSlot();
    }
  };
  useEffect(function () {
    if (monthEventFill) {
      setValueOpen(null);
      setSelectedTab([]);
    }
  }, [events, monthEventFill]);
  var monthComponents = useMemo(function () {
    return {
      // eslint-disable-next-line react/no-unstable-nested-components
      eventWrapper: function eventWrapper(propsEvent) {
        return /*#__PURE__*/_jsx(EventWrapper, Object.assign({}, propsEvent, {
          parent: segmentRef
        }));
      },
      dateCellWrapper: function dateCellWrapper(propsDCW) {
        return renderDateCellWrapper(propsDCW);
      }
    };
  }, [renderDateCellWrapper, segmentRef]);
  return /*#__PURE__*/_jsx(BigCalendar, Object.assign({
    components: {
      // eslint-disable-next-line react/no-unstable-nested-components
      toolbar: function toolbar(propsToolBar) {
        return /*#__PURE__*/_jsx(Toolbar, Object.assign({}, propsToolBar, {
          buttons: buttons
        }));
      },
      month: monthEventFill ? monthComponents : {}
    },
    defaultDate: defaultDate,
    events: events,
    mountNode: mountNode,
    localizer: localizer,
    selectable: true,
    messages: {
      allDay: 'journée',
      previous: 'précédent',
      next: 'suivant',
      noEventsInRange: 'Il n\'y a aucun événement dans cette période.',
      today: 'aujourd\'hui',
      tomorrow: 'demain',
      year: 'année',
      month: 'mois',
      week: 'semaine',
      day: 'jour',
      agenda: 'Agenda',
      date: 'date',
      time: 'heure',
      event: 'événement',
      work_week: 'semaine de travail',
      yesterday: 'hier',
      showMore: function showMore(total) {
        return "+ " + total + " \xE9v\xE9nement(s) suppl\xE9mentaire(s)";
      }
    },
    onSelectSlot: handleSelectSlot
  }, rest));
};
Calendar.handledProps = ["buttons", "events", "form", "monthEventFill", "mountNode", "onSelectSlot", "onSelectSlotEvent"];
Calendar.propTypes = {
  events: PropTypes.arrayOf(PropTypes.string, PropTypes.number),
  form: PropTypes.objectOf(PropTypes.string, PropTypes.number),
  onSelectSlot: PropTypes.func,
  buttons: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.symbol]),
  monthEventFill: PropTypes.bool,
  onSelectSlotEvent: PropTypes.func,
  mountNode: PropTypes.node
};
Calendar.defaultProps = {
  buttons: null,
  monthEventFill: false,
  onSelectSlotEvent: null,
  events: [],
  form: null,
  onSelectSlot: null
};
export default Calendar;